<template>
  <div v-if="show" class="kyc-address-document-proof-dialog-container">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>

    <single-message-dialog
      button-text="Dismiss"
      :show="showFileNotSupportedDialog"
      message="File format not supported. Please upload PDF or image."
      @onContinue="showFileNotSupportedDialog=false"
    ></single-message-dialog>

    <confirmation-dialog
      :show="showReAttachFileConfirmationDialog"
      :confirmation-message="reAttachFileConfirmationMessage"
      @onConfirm="attachIdDocument"
      @onNotConfirm="showReAttachFileConfirmationDialog=false"
    ></confirmation-dialog>

    <confirmation-dialog
      :show="showDismissDialog"
      :confirmation-message="dismissDialogMessage"
      @onConfirm="onDismissConfirm"
      @onNotConfirm="showDismissDialog=false"
    ></confirmation-dialog>

    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-with-cross">
        <weex-image
          class="dialog-cross-image"
          @click="onDismissClicked"
          :src="crossImage"
        ></weex-image>

        <div class="dialog-content-below-cross"></div>

        <weex-text class="font-size-base" v-html="documentTypeTitle"></weex-text>

        <wxc-dropdown
          class="dropdown-container"
          title="Document Type"
          default-item="Select"
          :config="dropdownConfig"
          :list="getDocumentTypes"
          @onItemSelected="onDocumentTypeSelected($event.value)"
        ></wxc-dropdown>

        <file-attach-button
          class="margin-top-10"
          ref="attach_id"
          file-attach-button-id="attach_id"
          text="Identity Proof"
          :attach-image-des-src="attachImageDesSrc"
          :disabled="true"
          :disabled-button-style="disabledButtonStyle"
          @attachFilesClicked="onAttachIdProofClicked"
          @filesAttached="onIdProofAttached($event.files[0])"
        ></file-attach-button>

        <div class="input_container" v-if="showIdProofDocumentNumberInp">
          <weex-text class="input_label">ID Proof Document Number</weex-text>
          <input
            class="input_with_border_bottom"
            v-model="idProofDocNumber"
            return-key-type="next">
        </div>

        <wxc-button
          text="Continue"
          size="big"
          class="margin-top-40 horizontal-center margin-bottom-20"
          type="blue"
          @wxcButtonClicked="onContinueClicked"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import EzUtils from "../../utils/EzUtils";
import { ImageResourcesUtil, DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import FileAttachButton from "../layout/FileAttachButton";
import AlertService from "../core/alert/AlertService";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import SingleMessageDialog from "./SingleMessageDialog";
import ConfirmationDialog from "./ConfirmationDialog";
import { DocumentDescription } from "../../utils/DocumentDetails";
import { Constants } from "../Constants";

export default {
  components: {
    WxcOverlay,
    WxcButton,
    WxcDropdown,
    FileAttachButton,
    SingleMessageDialog,
    ConfirmationDialog
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    documentTypeTitle: {
      type: String,
      default: "Select ID proof document type"
    },

    documentTypes: {
      type: Array,
      required: true,
      default: () => []
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    },

    idProofDocumentIdRequired: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  data: () => ({
    idFile: null,
    documentType: null,
    showFileNotSupportedDialog: false,
    showReAttachFileConfirmationDialog: false,
    showDismissDialog: false,
    idProofDocNumber: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    resetData() {
      this.idFile = null;
      this.documentType = null;
      this.showFileNotSupportedDialog = false;
      this.showReAttachFileConfirmationDialog = false;
      this.showDismissDialog = false;
    },

    showKYCIdProofOptions() {
      this.resetData();
    },

    onDismissClicked() {
      if (this.idFile) {
        this.showDismissDialog = true;
      } else {
        this.onDismissConfirm();
      }
    },

    onDismissConfirm() {
      this.showDismissDialog = false;
      this.$emit("onDialogDismiss");
    },

    onDocumentTypeSelected(documentType) {
      this.idFile = null;
      this.documentType = documentType;
    },

    onIdProofAttached(file) {
      if (EzUtils.isFileAllowedToUpload(file)) {
        this.idFile = file;
      } else {
        this.showFileNotSupportedDialog = true;
      }
    },

    onAttachIdProofClicked() {
      if (this.checkForValidation(false)) {
        if (this.idFile) {
          this.showReAttachFileConfirmationDialog = true;
        } else {
          this.attachIdDocument();
        }
      }
    },

    attachIdDocument() {
      this.showReAttachFileConfirmationDialog = false;
      this.$refs.attach_id.attachFile();
    },

    onContinueClicked() {
      if (this.checkForValidation(true)) {
        const attachedDocuments = {};
        const documentDetails = DocumentDescription.KYC_OSV_ID_PROOF;
        attachedDocuments[Constants.DOCUMENT_PURPOSE_ID + "_" + documentDetails.name] = {
          uri: this.idFile,
          documentName: documentDetails.name,
          documentDescription: documentDetails.description,
          documentDirectory: documentDetails.directory,
          documentCategory: Constants.DOCUMENT_PURPOSE_ID,
          documentType: this.documentType,
          documentProofNumber : this.idProofDocNumber

        };
        this.$emit("onContinue", attachedDocuments);
      }
    },

    checkForValidation(checkForDocuments) {
      if (!this.documentType) {
        this.showToast(MessageConstants.SELECT_DOCUMENT_TYPE);
        return false;
      }

      if (checkForDocuments) {
        if (!this.idFile) {
          this.showToast(MessageConstants.UPLOAD_DOCUMENT + " Identity proof.");
          return false;
        }
      }

      if(checkForDocuments && this.showIdProofDocumentNumberInp && !this.idProofDocNumber){
          this.showToast(MessageConstants.DOCUMENT_NUMBER_ERROR);
        return false;
      }

      return true;
    }
  },

  computed: {
    crossImage() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED);
    },

    getDocumentTypes() {
      const documentTypes = [];
      this.documentTypes && this.documentTypes.forEach(documentType => {
        documentTypes.push({
          title: EzUtils.removeUnderscoreFromString(documentType, ["ID", "PAN"]),
          value: documentType
        });
      });

      return documentTypes;
    },

    getReadableDocumentType() {
      return EzUtils.removeUnderscoreFromString(this.documentType, ["ID", "PAN"]);
    },

    attachImageDesSrc() {
      if (this.idFile) {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN);
      } else {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
      }
    },

    reAttachFileConfirmationMessage() {
      return `Do you want to reupload <b>${this.getReadableDocumentType}</b>? <br>If yes, previous uploaded <b>${this.getReadableDocumentType}</b> will be deleted.`;
    },

    dismissDialogMessage() {
      return `Do you want to close? <br>If yes, previous uploaded <b>${this.getReadableDocumentType}</b> will be deleted.`;
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    disabledButtonStyle() {
      return {
        backgroundColor: "#ffffff",
        "border-width": "1px",
        "border-color": "gray",
        "border-style": "solid"
      };
    },

    showIdProofDocumentNumberInp(){
        return this.documentType!=="AADHAAR" && this.idProofDocumentIdRequired;
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.kyc-address-document-proof-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
